/* unplugin-vue-components disabled */export default defineComponent({
  name: 'MyDepartment',
  components: {},
  setup: function setup() {
    return {};
  }
});